import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import LogicalTest from "../pages/screening/logical";
import MemorizationTest from "../pages/screening/memorization";
import RegistrationForm from "../pages/screening/registration";
import Instructions from "../pages/screening/instruction";
import AptitudeTest from "../pages/screening/aptitude";
import ThankYouPage from "../pages/screening/thank-you";
import ListeningTest from "../pages/screening/listening";
import Login from "../pages/screening/login";
import Writing from "../pages/screening/writing";
import Completion from "../pages/screening/completion";
import ListeningInstructionPage from "../pages/screening/listening-instruction";
import AdminLogin from "../pages/admin/login";
import Dashboard from "../pages/admin/dashboard";
import PlacementLogin from "../pages/placement/login";
import PlacementDashboard from "../pages/placement/dashboard";
import Evaluation from "../pages/admin/evaluation";
import SalesRegistration from "../pages/screening/salesRegistration";
import PlacementResult from "../pages/placement/result";
const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<RegistrationForm />} />
      <Route path="/registration" element={<Navigate to="/" replace />} />
      <Route path="/logical" element={<LogicalTest />} />
      <Route path="/new/registration" element={<SalesRegistration />} />
      <Route path="/instructions" element={<Instructions />} />
      <Route path="/memorization" element={<MemorizationTest />} />
      <Route path="/aptitude" element={<AptitudeTest />} />
      <Route path="/thank-you" element={<ThankYouPage />} />
      <Route path="/listening/:questionId" element={<ListeningTest />} />
      <Route path="/login" element={<Login />} />
      <Route path="/writing" element={<Writing />} />
      <Route path="/completion" element={<Completion />} />
      <Route
        path="/listening-instructions"
        element={<ListeningInstructionPage />}
      />
      <Route path="/trainer/login" element={<AdminLogin />} />
      <Route path="/trainer/dashboard" element={<Dashboard />} />
      <Route path="/placement/login" element={<PlacementLogin />} />
      <Route path="/placement/dashboard" element={<PlacementDashboard />} />
      <Route path="/placement/result" element={<PlacementResult />} />
      <Route path="/candidates-evaluation" element={<Evaluation />} />
    </Routes>
  );
};

export default AppRoutes;
